import { memo } from 'react'

import HotspotsSelectNode from '../HotspotsSelectNode'

const HideHotspotsActionNode = ({ cubeId, ...props }) => {
  return (
    <HotspotsSelectNode
      label="Ocultar hotspots"
      cubeId={cubeId}
      allowEmpty
      multiple
      {...props}
    />
  )
}
export default memo(HideHotspotsActionNode)
